/* eslint-disable @typescript-eslint/no-explicit-any */
import { UpperCasePipe } from '@angular/common';
import { Component, inject, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { FlexLayoutModule } from '@angular/flex-layout';
import { FormsModule, ReactiveFormsModule, UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatButton, MatIconButton } from '@angular/material/button';
import { MatCard, MatCardActions, MatCardContent, MatCardTitle } from '@angular/material/card';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { MatError, MatFormField, MatLabel } from '@angular/material/form-field';
import { MatIcon } from '@angular/material/icon';
import { MatInput } from '@angular/material/input';
import { MatToolbar } from '@angular/material/toolbar';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'i18n-translation-edit-form',
  templateUrl: './translation-edit-form.component.html',
  styleUrls: ['./translation-edit-form.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    MatCard,
    MatCardTitle,
    MatToolbar,
    FlexLayoutModule,
    MatIconButton,
    MatIcon,
    MatCardContent,
    FormsModule,
    ReactiveFormsModule,
    MatFormField,
    MatLabel,
    MatInput,
    MatError,
    MatCardActions,
    MatButton,
    UpperCasePipe,
    TranslatePipe
  ]
})
export class TranslationEditFormComponent implements OnInit {
  public editFrom: UntypedFormGroup;
  public translations: { key: string; required: boolean; value: string }[] = [];

  public matDialogRef: MatDialogRef<TranslationEditFormComponent> = inject(MatDialogRef<TranslationEditFormComponent>);
  public data: {
    languages: string[];
    rowData: any;
  } = inject(MAT_DIALOG_DATA);

  public ngOnInit(): void {
    this.translations = [
      {
        key: 'key',
        required: true,
        value: this.data.rowData.key
      }
    ];
    this.data.languages.forEach((lang: string) => {
      this.translations.push({
        key: lang,
        required: false,
        value: this.data.rowData[lang].value
      });
    });
    this.initForm();
  }

  public close(): void {
    this.matDialogRef.close();
  }

  public initForm(): void {
    const controls = {};
    this.translations.forEach((item: { key: string; required: boolean; value: string }) => {
      controls[item.key] = new UntypedFormControl(item.value, item.required ? [Validators.required] : []);
    });
    this.editFrom = new UntypedFormGroup(controls);
  }

  public save(): void {
    if (this.editFrom.valid) {
      const newValues = {
        ...this.data.rowData,
        key: this.editFrom.value.key
      };
      this.data.languages.forEach((lang: string) => {
        newValues[lang].value = this.editFrom.value[lang];
      });
      this.matDialogRef.close(newValues);
    }
  }
}
